import { get, post } from './api-client';

export const commonService = {
    getInTouch: (data) => post('/common/contactUsSend', data),

    acceptCookie: () => get('/common/euCookieLawAccept'),

    getFaqList: () => get('/faq/getFaqList'),

    getAboutUsPageData: () => get('/aboutUs/getPageData'),

    getHomePageData: () => get('/common/getHomePageData'),

    setLanguage: (id) => post(`/common/setLanguage/${id}?returnUrl=home`)
};